import { configureStore } from "@reduxjs/toolkit";
import LogRocket from "logrocket";
import chatReducer from "@/redux/reducers/chat";

const makeStore = () =>
  configureStore({
    reducer: {
      chat: chatReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(LogRocket.reduxMiddleware()),
    devTools: process.env.environment !== "production",
  });

export default makeStore;
